import { AddressPurpose as SatsConnectAddressPurpose } from 'sats-connect';
// eslint-disable-next-line no-shadow
export var AddressPurpose;
(function (AddressPurpose) {
    AddressPurpose["Ordinal"] = "ordinal";
    AddressPurpose["Payment"] = "payment";
    AddressPurpose["Stacks"] = "stx";
})(AddressPurpose || (AddressPurpose = {}));
export function mapSatsConnectAddressPurpose(purpose) {
    switch (purpose) {
        case SatsConnectAddressPurpose.Payment:
            return AddressPurpose.Payment;
        case SatsConnectAddressPurpose.Ordinals:
            return AddressPurpose.Ordinal;
        case SatsConnectAddressPurpose.Stacks:
            return AddressPurpose.Stacks;
        default:
            return undefined;
    }
}
//# sourceMappingURL=BitcoinConnector.js.map